import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator, ValidatorFn } from '@angular/forms';

export function regexValidator(nameRe: RegExp): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null =>
    nameRe.test(control.value) ? null : { validRegex: { value: control.value } };
}

@Directive({
  selector: '[appValidRegex]',
  providers: [{ provide: NG_VALIDATORS, useExisting: ValidatorDirective, multi: true }]
})
export class ValidatorDirective implements Validator {
  @Input('appValidRegex') public validRegex = '';

  public validate(control: AbstractControl): ValidationErrors | null {
    if (!this.validRegex) {
      return null;
    }

    const validator = regexValidator(new RegExp(this.validRegex, 'i'));
    return validator(control);
  }
}
